<template>
  <router-link
    v-if="router && router.name"
    v-show="!hidden"
    tag="li"
    :to="router"
    :class="{ 'has-badge': hasBadge }"
  >
    <a
      :style="{ color, backgroundColor }"
      @click="handleRouterNavigation()"
    >
      <img
        v-if="iconSrc"
        :src="iconSrc"
        alt="icon"
      >
      <i
        v-else
        class="icon"
        :class="iconClass"
      /> <span
        class="text"
        v-html="text"
      />
      <span
        v-if="hasBadge"
        class="pull-right-container"
      >
        <small
          class="label pull-right"
          :class="[!badge.color ? 'bg-red' : `bg-${badge.color}`]"
        >{{ badge.text }}</small>
      </span>
      <div
        v-if="helpText"
        class="help-text"
        :class="{ 'hidden-on-collapse': helpTextHiddenOnCollapse }"
        v-html="helpText"
      />
    </a>
  </router-link>
  <li
    v-else
    v-show="!hidden"
    :class="itemClasses"
    :style="{ backgroundColor }"
  >
    {{ header ? text.toUpperCase() + ':' : '' }}
    <a
      v-if="!header"
      :href="link ? link : (hasChildItems ? '#' : false)"
      :target="target"
      :style="{ color, backgroundColor, borderLeftColor }"
    >
      <img
        v-if="iconSrc"
        :src="iconSrc"
        alt="icon"
      >
      <i
        v-else
        class="icon"
        :class="iconClass"
      /> <span
        class="text"
        v-html="text"
      />
      <span class="pull-right-container">
        <small
          v-if="hasBadge"
          class="label pull-right"
          :class="[!badge.color ? 'bg-red' : `bg-${badge.color}`]"
        >{{ badge.text }}</small>
        <i
          v-else-if="hasChildItems"
          class="fa fa-angle-left pull-right"
        />
      </span>
      <div
        v-if="helpText"
        class="help-text"
        :class="{ 'hidden-on-collapse': helpTextHiddenOnCollapse }"
        v-html="helpText"
      />
    </a>
    <ul
      v-if="hasChildItems"
      class="treeview-menu"
      :style="{ display: open ? 'block' : 'none', backgroundColor }"
    >
      <template v-for="(item, index) in items">
        <router-link
          v-if="item.router && item.router.name"
          v-show="!item.hidden"
          :key="index"
          tag="li"
          :to="item.router"
        >
          <a @click="handleRouterNavigation()">
            <img
              v-if="item.iconSrc"
              :src="item.iconSrc"
              alt="icon"
            >
            <i
              v-else
              class="icon"
              :class="item.iconClass"
            /> <span v-html="item.text" />
            <span
              v-if="item.badge"
              class="pull-right-container"
            >
              <small
                class="label pull-right"
                :class="[!item.badge.color ? 'bg-red' : `bg-${item.badge.color}`]"
              >{{ item.badge.text }}</small>
            </span>
            <div
              v-if="item.helpText"
              class="help-text"
              :class="{ 'hidden-on-collapse': helpTextHiddenOnCollapse }"
              v-html="item.helpText"
            />
          </a>
        </router-link>
        <li
          v-else
          v-show="!item.hidden"
          :key="index"
        >
          <template v-if="item.link">
            <a :href="item.link || false">
              <img
                v-if="item.iconSrc"
                :src="item.iconSrc"
                alt="icon"
              >
              <i
                v-else
                class="icon"
                :class="item.iconClass"
              /> <span v-html="item.text" />
            </a>
          </template>
          <template v-else>
            <a>
              <img
                v-if="item.iconSrc"
                :src="item.iconSrc"
                alt="icon"
              >
              <i
                v-else
                class="icon"
                :class="item.iconClass"
              /> <span v-html="item.text" />
            </a>
          </template>
        </li>
      </template>
    </ul>
  </li>
</template>

<script>

/**
 * Элемент бокового меню.
 */
export default {
  name: 'SidebarMenuItem',
  props: {
    /**
     * Является ли элемент разделительным заголовком.
     */
    header: {
      type: Boolean,
      default: false
    },
    /**
     * Класс для иконки слева от пункта меню. Игнорируется если задан iconSrc.
     */
    iconClass: {
      type: String,
      default: 'icon fa fa-th'
    },
    /**
     * Путь к файлу иконки. Если задан iconClass игнорируется.
     */
    iconSrc: {
      type: String,
      default: ''
    },
    /**
     * Текст элемента (можно HTML).
     */
    text: {
      type: String,
      default: ''
    },
    /**
     * Цвет текста элемента.
     */
    color: {
      type: String,
      default: ''
    },
    /**
     * Текст для вывода под основным текстом элемента (можно HTML).
     */
    helpText: {
      type: String,
      default: ''
    },
    /**
     * Скрывать ли Текст для вывода под основным текстом элемента, если sidebar свернут (класс .sidebar-collapse)
     */
    helpTextHiddenOnCollapse: {
      type: Boolean,
      default: false
    },
    /**
     * Бэйдж справа от пункта меню.
     */
    badge: {
      type: Object,
      default () {
        return {}
      }
    },
    /**
     * Подпункты меню.
     */
    items: {
      type: Array,
      default () {
        return []
      }
    },
    /**
     * Описание роута пункта меню.
     */
    router: {
      type: Object,
      default () {
        return {
          name: ''
        }
      }
    },
    /**
     * Адрес ссылки пункта меню (если не указан router).
     */
    link: {
      type: String,
      default: ''
    },
    /**
     * Цвет фона пункта меню (если не указан router).
     */
    backgroundColor: {
      type: String,
      default: ''
    },
    /**
     * Цвет левой границы пункта меню
     */
    borderLeftColor: {
      type: String,
      default: ''
    },
    /**
     * Развернуто или нет меню с подпунктами.
     */
    open: {
      type: Boolean,
      default: false
    },
    /**
     * Скрыт или нет элемент.
     */
    hidden: {
      type: Boolean,
      default: false
    },
    /**
     * Нужно ли открывать ссылку в новой вкладке (если не указан router)
     */
    target: {
      type: String,
      default: ''
    }
  },
  computed: {
    /**
     * Имеет ли элемент меню подпункты.
     *
     * @returns {boolean}
     */
    hasChildItems () {
      return this.items.length > 0
    },
    /**
     * Имеет ли элемент меню бэйдж.
     *
     * @returns {boolean}
     */
    hasBadge () {
      return !!this.badge.text
    },
    /**
     * Классы элемента меню.
     *
     * @returns {string}
     */
    itemClasses () {
      if (this.header) {
        return 'header'
      }

      const classes = []
      if (this.hasChildItems) {
        classes.push('treeview')
      }

      if (this.open) {
        classes.push('menu-open')
      }

      if (this.hasBadge) {
        classes.push('has-badge')
      }

      for (const item of this.items) {
        if (item.router && item.router.name === this.$route.name) {
          classes.push('active')
          break
        }

        if (item.link === this.$route.path) {
          classes.push('active')
          break
        }
      }

      return classes.join(' ')
    }
  },
  methods: {
    handleRouterNavigation () {
      this.$root.$emit('sidebarRouteNavigation')
    }
  }
}
</script>

<style scoped>
.text {
  display: inline-block;
}

.has-badge .text {
  width: 130px;
  white-space: normal;
}

.icon {
  float: left;
  margin-top: 3px;
}

.help-text {
  white-space: normal;
  font-size: 0.9em;
}

img {
  vertical-align: top;
}

.sidebar-mini.sidebar-collapse .hidden-on-collapse {
  display: none;
}
</style>
